/* ========================================================================== */
/* File: src/components/layout/Footer.js (New File)             */
/* ========================================================================== */
import React from 'react';



const Footer = () => {
    const currentYear = new Date().getFullYear();
    const appVersion = process.env.REACT_APP_VERSION;

    return (
        <footer className="footer">
            <div className="footer-content">
                Copyright © {currentYear}. Build and Managed By <a href="https://www.thewesterntech.com/" target="_blank" rel="noopener noreferrer">The WesternTech</a>

                {appVersion && (
                    <span className="footer-version">
                        v{appVersion}
                    </span>
                )}

            </div>
        </footer>
    );
};

export default Footer;